import { BacktestSel, BacktestType } from "@/features/backtest";
import { useRootSelector } from "@/infrastructure/hooks";
import { TitleCamelCase } from "@/utils/string";
import { PortfolioRiskReturn } from "@/features/backtest/types";

export const useStatsDat = (
  typeKey: keyof BacktestType.SingleResult | string,
  statsKey: keyof BacktestType.PortfolioStats
) => {
  const result = useRootSelector(BacktestSel.result);
  const strategyStats = result.groupResult.strategy.portfolioStatistics[statsKey] as Record<string, number>;

  const selectedStats =
    typeKey === "strategy" || typeKey === "longTerm" || typeKey === "peerStrategy"
      ? (result.groupResult[typeKey]!.portfolioStatistics[statsKey] as Record<string, number>)
      : (result.singleResult.find(e => e.strategy === typeKey)!.results.portfolioStatistics[statsKey] as Record<
          string,
          number
        >);

  const excludedStats: (keyof BacktestType.PortfolioRiskReturn)[] = [
    "stability",
    "rSquared",
    "cagr",
    "sharpeRatio",
    "annualReturn",
    "annualVolatility",
    "totalReturn"
  ];

  //Temporary filter out some stats
  return Object.entries(strategyStats)
    .filter(([k, _v]) => !excludedStats.includes(k as keyof BacktestType.PortfolioRiskReturn))
    .map(([k, v]) => ({
      stats: TitleCamelCase(k),
      strategy: v,
      comparison: selectedStats[k] || "NA"
    }));
};
